var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Login',{attrs:{"redirect":_vm.$route.params.redirect},on:{"login":_vm.login}})
}
var staticRenderFns = []

export { render, staticRenderFns }